module.exports = __webpack_public_path__ + "img/smile.67c60590.svg";